import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import {
  ICreateServicoEntrada,
  IGetServicoEntradaByServicoEntradaCavaloBody,
  IGetServicosEntradaByCavalo,
  IGetServicosEntradaByGateEntrada,
  IGetServicosParams,
  IUpdateServicoEntrada
} from './servicoEntrada.model';

@Injectable({
  providedIn: 'root'
})
export class ServicoEntradaService {
  constructor(private http: HttpClient) {}

  public CreateServico(body: ICreateServicoEntrada): Observable<any> {
    const url = `${environment.baseURL}ServicoEntrada/CreateServicoEntrada`;

    return this.http.post<any>(url, body);
  }

  public UpdateServico(
    id: number,
    body: IUpdateServicoEntrada
  ): Observable<any> {
    const url = `${environment.baseURL}ServicoEntrada/UpdateServicoEntrada?id=${id}`;

    return this.http.put<any>(url, body);
  }

  public GetServicos(body?: IGetServicosParams): Observable<any> {
    const url = `${environment.baseURL}ServicoEntrada/GetServicosEntradaPaginated`;
    let params: any = {};

    if (body?.FK_SRVC) params.FK_SRVC = body.FK_SRVC;

    if (body?.FK_EPSA) params.FK_EPSA = body.FK_EPSA;

    if (body?.FK_GATE_ENTR) params.FK_GATE_ENTR = body.FK_GATE_ENTR;

    if (body?.TX_PLCA_CAVA) params.TX_PLCA_CAVA = body.TX_PLCA_CAVA;

    if (body?.NM_MTRT) params.NM_MTRT = body.NM_MTRT;

    if (body?.DT_SRVC_ENTR_INIC)
      params.DT_SRVC_ENTR_INIC = body.DT_SRVC_ENTR_INIC;

    if (body?.DT_SRVC_ENTR_FIM) params.DT_SRVC_ENTR_FIM = body.DT_SRVC_ENTR_FIM;

    if (body?.PAGE_NUMBER) params.PAGE_NUMBER = body.PAGE_NUMBER;

    if (body?.PAGE_SIZE) params.PAGE_SIZE = body.PAGE_SIZE;

    if (body?.FK_MTRT_EXTR) params.FK_MTRT_EXTR = body.FK_MTRT_EXTR;

    return this.http.get<any>(url, { params });
  }

  public GetServicoById(id?: number): Observable<any> {
    const url = `${environment.baseURL}ServicoEntrada/GetServicoEntradaById`;
    let params: any = {};

    if (id) {
      params.id = id;
    }

    return this.http.get<any>(url, { params });
  }

  public GetServicoByPreco(PK_GATE_ENTR?: number): Observable<any> {
    const url = `
      ${environment.baseURL}ServicoEntrada/GetServicoEntradaPrecoByEntrada?PK_GATE_ENTR=${PK_GATE_ENTR}
    `;

    return this.http.get<any>(url);
  }

  public GetServicosEntradaByCavalo(body: IGetServicosEntradaByCavalo) {
    const url = `${environment.baseURL}ServicoEntrada/GetServicosEntradaByCavalo`;
    let params: any = {};

    if (body.TX_PLCA_CAVA) {
      params.TX_PLCA_CAVA = body.TX_PLCA_CAVA;
    }

    return this.http.get<any>(url, { params });
  }

  public GetServicosEntradaByGateEntrada(
    body: IGetServicosEntradaByGateEntrada
  ) {
    const url = `${environment.baseURL}ServicoEntrada/GetServicosEntradaByGateEntrada`;
    let params: any = {};

    params.PK_GATE_ENTR = body.PK_GATE_ENTR;

    return this.http.get<any>(url, { params });
  }

  public GetServicoEntradaByServicoEntradaAndCavalo(
    body?: IGetServicoEntradaByServicoEntradaCavaloBody
  ) {
    const url = `${environment.baseURL}ServicoEntrada/GetServicoEntradaByServicoEntradaAndCavalo`;
    let params: any = {};

    if (body?.PK_SRVC) {
      params.PK_SRVC = body.PK_SRVC;
    }
    if (body?.PK_SRVC_ENTR) {
      params.PK_SRVC_ENTR = body.PK_SRVC_ENTR;
    }
    if (body?.PK_AGND) {
      params.PK_AGND = body.PK_AGND;
    }

    if (body?.TX_PLCA_CAVA) {
      params.TX_PLCA_CAVA = body.TX_PLCA_CAVA;
    }

    return this.http.get<any>(url, { params });
  }

  public GetReceiptServicoEntradaById(
    id: number,
    tipoDocumento: number
  ): Observable<any> {
    const url = `${environment.baseURL}ServicoEntrada/GetReceiptServicoEntradaById`;
    const params: any = {
      PK_GATE_ENTR: 0,
      FL_TIPO_DOCU: 0
    };

    params.PK_GATE_ENTR = id;
    params.FL_TIPO_DOCU = tipoDocumento;

    return this.http.get<any>(url, { params });
  }
}
